import { User } from "./models/user";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationExtras,
} from "@angular/router";
import { AuthenticateService } from "./services/authentication/authenticate.service";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ChatService } from "./services/chat/chat.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  user: User;
  constructor(
    public authenticateService: AuthenticateService,
    public router: Router,
    public chatService: ChatService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authenticateService.getLoggedInUserDetail().pipe(
      map((res) => {
        if (res && res.patientProfile && res.patientProfile.id > 0) {
          return true;
        } else {
          this.router.navigate(["/session"], {
            queryParams: route.queryParams,
          } as NavigationExtras);
          return false;
        }
      }),
      catchError((err) => {
        this.router.navigate(["/session"], {
          queryParams: route.queryParams,
        } as NavigationExtras);
        return of(false);
      })
    );
  }
}
